import { render, staticRenderFns } from "./examplesApplication.vue?vue&type=template&id=015c96e3&scoped=true&"
import script from "./examplesApplication.vue?vue&type=script&lang=js&"
export * from "./examplesApplication.vue?vue&type=script&lang=js&"
import style0 from "./examplesApplication.vue?vue&type=style&index=0&id=015c96e3&lang=scss&scoped=true&"
import style1 from "./examplesApplication.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015c96e3",
  null
  
)

export default component.exports